import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import ArrowIcon from "@material-ui/icons/KeyboardArrowRight";
import styled, { css } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.leftContainer {
    padding: 0;
    @media (max-width: 1026px) {
      padding: 20px 0 0 0;
    }
  }
  &.centeredContainer {
    align-items: flex-start;
    width: 100%;
    margin: 0 auto;
    @media (min-width: 940px) {
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 70%;
    }
  }
`;
const Underline = styled.hr`
  border-top: 2px solid;
  border-color: #f15e4e; /* theme.palette.primary.main */
  width: 60px;
  height: 0;
  margin-bottom: 20px;
`;
const BaseTitleStyle = css`
  font-size: 2rem;
  font-weight: 500;
  color: #08052c; /* theme.palette.colors.darkBlue */
  margin: 5px 0 15px 0;
  @media (min-width: 940px) {
    font-size: 2.8rem;
  }
`;
const H1 = styled.h1`
  ${BaseTitleStyle}
`;
const H2 = styled.h2`
  ${BaseTitleStyle}
`;

const LinkLabel = styled.h5`
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: 400;
  @media (min-width: 940px) {
    &:hover {
      text-decoration: underline;
    }
  }
`;
const Path = styled((props) => <Link {...props} />)`
  align-items: center;
  margin: 0;
  letter-spacing: 1px;
  @media (min-width: 940px) {
    display: flex;
    justify-content: center;
    margin: 15px 0;
  }
`;
const Arrow = styled.span`
  transition: padding 0.3s;
  font-weight: 400;
  &:hover {
    padding-right: 7px;
  }
`;

const SectionHead = ({
  disableUnderline,
  isCentered,
  link,
  linkLabel,
  type,
  innerStyle,
  title,
  children,
}) => {
  const underline = disableUnderline === true ? null : <Underline />;

  const linkUrl = link ? (
    <Path>
      <Link to={link}>
        <LinkLabel>
          <Arrow>{linkLabel}</Arrow>
          <ArrowIcon />
        </LinkLabel>
      </Link>
    </Path>
  ) : null;

  return (
    <Container
      className={isCentered ? "centeredContainer" : "leftContainer"}
      style={innerStyle}
    >
      {title && type === "h1" && <H1>{title}</H1>}
      {title && type === "h2" && <H2>{title}</H2>}
      {title && underline}
      {children ? children : null}
      {linkUrl}
    </Container>
  );
};

SectionHead.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  disableUnderline: PropTypes.bool,
  isCentered: PropTypes.bool,
  hasLink: PropTypes.bool,
  innerStyle: PropTypes.object,
};

SectionHead.defaultProps = {
  title: "",
  type: "h1",
  link: "",
  linkLabel: "",
  isCentered: false,
  disableUnderline: false,
  hasLink: false,
  innerStyle: undefined,
};

export default SectionHead;
